<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
	<div class="dictionaryList">
		<!--筛选条-->
    <el-form class="z-plate__operation-bar" inline @submit.native.prevent>
			<div style="text-align: right;padding: 0 10px 10px;float: right;">
        <el-button type="primary" size="small" @click="handleAdd()" id="dictAddGroup">新增字典组</el-button>
      </div>
    </el-form>
		<section class="z-plate__container">
			<div slot="content" class="dict-table-content">
				<el-table :data="tableDatas" style="width: 100%" height="calc(100% - 30px)" v-loading="loading" border>
          <el-table-column type="index" label="序号" width="80"></el-table-column>
          <el-table-column prop="dictName" label="名称"></el-table-column>
          <el-table-column prop="dictCode" label="标识"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button :id="scope.row.dictId+'configDictI'" @click="handleClick(scope.row)" size="small">配置字典项</el-button>
              <!--<el-button @click="handleInfo(scope.row)" type="primary" size="small">查看</el-button>-->
              <el-button :id="scope.row.dictId+'dictEdit'" @click="handleEdit(scope.$index, scope.row)" type="primary" size="small">编辑</el-button>
              <el-button :id="scope.row.dictId+'dictDel'" @click="handleDelete(scope.$index, scope.row)" type="danger" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
			</div>
		</section>

    <!--编辑-->
    <el-dialog title="修改信息" :visible.sync="dialogFormVisible" @close="refresh" :close-on-click-modal="false">
      <el-form :model="selectTable" :rules="rules" ref="selectTable">
        <el-form-item label="名称" prop="dictName" label-width="100px">
          <el-input v-model="selectTable.dictName" auto-complete="off" id="dictEditName"></el-input>
        </el-form-item>
        <el-form-item label="标识" prop="dictCode" label-width="100px">
          <el-input v-model="selectTable.dictCode" id="dictEditCode"></el-input>
        </el-form-item>
        <el-form-item label="排序号" prop="dictSort" label-width="100px">
          <el-input v-model="selectTable.dictSort" id="dictEditSort"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="dictDes" label-width="100px">
          <el-input v-model="selectTable.dictDes" type="textarea" id="dictEditDes"
                    maxlength="100" placeholder="100字以内"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button id="dictEditCancel" @click="dialogFormVisible = false">取 消</el-button>
        <el-button id="dictEditSubmit" type="primary" @click="submitForm('selectTable','update')">确 定</el-button>
      </div>
    </el-dialog>

    <!--显示字典组下的字典项列表-->
    <el-dialog title="字典项列表" :visible.sync="dialogTableVisible"
               width="60%" @close="cleanData" :close-on-click-modal="false">
      <el-button @click="handleAdd()" type="primary" size="small" id="dictAddI">添加字典项</el-button>
      <el-table :data="dictIDatas" v-loading="loading">
        <el-table-column type="index" label="序号" ></el-table-column>
        <el-table-column prop="dictName" label="名称" ></el-table-column>
        <el-table-column prop="dictCode" label="标识" ></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <!--<el-button @click="handleInfo(scope.row)" type="primary" size="small">查看</el-button>-->
            <el-button :id="scope.row.dictId+'dictIEdit'" @click="handleEdit(scope.$index, scope.row)" type="primary" size="small" >编辑</el-button>
            <el-button :id="scope.row.dictId+'dictIDel'" @click="handleDelete(scope.$index, scope.row)" type="danger" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!--添加-->
    <el-dialog title="添加" :visible.sync="dialogAddFormVisible" @close="resetForm('ruleForm')" :close-on-click-modal="false">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="名称" prop="dictName">
          <el-input v-model="ruleForm.dictName" id="dictAddName"></el-input>
        </el-form-item>
        <el-form-item label="标识" prop="dictCode">
          <el-input v-model="ruleForm.dictCode" id="dictAddCode"></el-input>
        </el-form-item>
        <el-form-item label="排序号" prop="dictSort">
          <el-input v-model="ruleForm.dictSort" id="dictAddSort"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="dictDes" >
          <el-input type="textarea" v-model="ruleForm.dictDes" id="dictAddDes"
                    maxlength="100" placeholder="100字以内" ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button id="dictAddSumbit" type="primary" @click="submitForm('ruleForm','add')">立刻添加</el-button>
          <el-button id="dictAddReset" @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import moment from "moment";
export default {
  name: 'dictionaryList',
  data: function () {
    var validateSort = (rule, value, callback) => {
      var str=/^\d+$/g;
      var flag = str.test(value);
      if (flag) {
        callback();
      } else {
        callback(new Error('输入值必须为大于等于0的正整数'));
      }
    };
    return {
      tableDatas: [],
      selectTable: {},
      dialogFormVisible: false,
      dialogTableVisible: false,
      dialogAddFormVisible: false,
      dictIDatas: [],
      loading: true,
      ruleForm: {
        dictName: '',
        dictType: '',
        dictCode: '',
        dictGroup: '',
        dictSort: '',
        dictDes: ''
      },
      rules: {
        dictName: [
          {required: true, message: '请输入字典名称', trigger: 'blur'},
          {max: 20, message: '长度不超过 20 个字符', trigger: 'blur'}
        ],
        dictCode: [
          {required: true, message: '请输入字典标识(字符唯一)', trigger: 'blur'}
        ],
        dictSort: [
          {required: true, message: '请输入字典排序号', trigger: 'blur'},
          {validator: validateSort}
        ],
        dictDes: [
          {max: 100, message: '长度在 100 个字符以内', trigger: 'blur'}
        ]
      }
    }
  },
  components:{
  },
	props: {},
	created() {
	},
	mounted() {
    this.queryDiciionaryList();
	},
	methods: {
	  //字典组列表
    queryDiciionaryList() {
      var _this = this;
      _this.$post('sys/findSysDictList',{
        dictType: 'G'
      }).then(function(response){
        if (response.code == '1'){
          _this.loading = false;
          _this.tableDatas = response.result.dictionaryList;
        }
      }).catch(function (error) {
//      console.log(error);
      })
    },
    //查看该字典组下的字典项列表
    handleClick(row){
      //给新增使用
      this.selectTable = row;
      this.dialogTableVisible = true;
      var _this = this;
      var dictGroup = '';
      if(row.dictType === 'G'){
        dictGroup = row.dictCode;
      }else if(row.dictType === 'I'){
        dictGroup = row.dictGroup;
      }
      _this.$post('sys/findSysDictList',{
        dictType: 'I',
        dictGroup: dictGroup
      }).then(function(response){
        if (response.code == '1'){
          _this.loading = false;
          _this.dictIDatas = response.result.dictionaryList;
        }
      }).catch(function (error) {
//      console.log(error);
      })

    },
    //增加弹窗
    handleAdd: function () {
      this.dialogAddFormVisible = true;
      /*if(this.selectTable.dictType === 'G'){
        this.ruleForm.dictGroup = this.selectTable.dictCode;
      }*/
    },
    //验证表单
    submitForm(formName,type) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(type === 'update'){
            this.updateDictionary();
          }else if(type === 'add'){
            this.addDictionary();
          }
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.refresh();
    },
    //请求后台增加
    addDictionary:function () {
      var row = this.selectTable;
      var _this = this;
      var dictGroup = '';
      if(row.dictType === 'G'){
        dictGroup = row.dictCode;
      }else if(row.dictType === 'I'){
        dictGroup = row.dictGroup;
      }
      if(row.dictType !== undefined || row.dictType === 'I'){
        _this.$post('sys/addSysDict',{
          dictGroup: dictGroup,
          dictName: _this.ruleForm.dictName,
          dictCode: _this.ruleForm.dictCode,
          dictSort: _this.ruleForm.dictSort,
          dictDes: _this.ruleForm.dictDes
        }).then(function (response) {
          if (response.code == '1') {
            _this.dialogAddFormVisible = false;
            _this.$message({
              type: 'success',
              message:  '添加字典成功'
            });
            _this.handleClick(row);
          }else{
            _this.$message({
              type: 'error',
              message: response.msg
            });
          }
        }).catch(function (error) {
//        console.log(error);
        })
      }else {
        _this.$post('sys/addSysDictGroup',{
          dictName: _this.ruleForm.dictName,
          dictCode: _this.ruleForm.dictCode,
          dictSort: _this.ruleForm.dictSort,
          dictDes: _this.ruleForm.dictDes
        }).then(function (response) {
          if (response.code == '1') {
            _this.dialogAddFormVisible = false;
            var flag = response.result.deleteCode;
            _this.$message({
              type: 'success',
              message:  '添加字典组成功'
            });
            _this.queryDiciionaryList();
          }else{
            _this.$message({
              type: 'error',
              message: response.msg
            });
          }
        }).catch(function (error) {
//        console.log(error);
        })
      }
    },
    //删除
    handleDelete(index, row) {
      this.$confirm('是否删除此记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var dictType = row.dictType;
        var _this = this;
        _this.$post('sys/deleteSysDict',{
          dictId: row.dictId
        }).then(function(response){
          if (response.code == '1') {
            var flag = response.result.deleteCode;
            _this.$message({
              type: flag ? 'success':'warning',
              message: flag ? '删除成功':'删除失败'
            });
            if(dictType == 'G'){
              _this.queryDiciionaryList();
            }else {
              _this.handleClick(row);
            }
          }else{
            _this.$message({
              type: 'error',
              message: response.msg
            });
          }
        }).catch(function (error) {
//        console.log(error);
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //编辑窗口
    handleEdit(index, row) {
      this.selectTable = row;
      this.dialogFormVisible = true;
    },
    //更新
    updateDictionary(){
      this.dialogFormVisible = false;
      var _this = this;
      var dictType = _this.selectTable.dictType;
      _this.$post('sys/editSysDict',{
        dictId: _this.selectTable.dictId,
        dictName: _this.selectTable.dictName,
        dictCode: _this.selectTable.dictCode,
        dictDes: _this.selectTable.dictDes,
        dictSort: _this.selectTable.dictSort
      }).then(function (response) {
        if (response.code == '1') {
          _this.$message({
            type: 'success',
            message: '更新信息成功'
          });
          if(dictType == 'G'){
            _this.queryDiciionaryList();
          }else {
            _this.handleClick(_this.selectTable);
          }
        }else{
          _this.$message({
            type: 'error',
            message: response.msg
          });
        }
      }).catch(function (error) {
//      console.log(error);
      })
    },
    //日期处理
    dateFormat:function(row, column){
      var date = row[column.property];
      if (date === undefined) {
        return "";
      }
      return moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
    //清空数据
    cleanData(){
      this.dictIDatas = [];
      this.selectTable = {};
    },
    //编辑框关闭跳转
    refresh(){
      var dictType = this.selectTable.dictType;
      if(dictType === 'G' || dictType === undefined){
        this.queryDiciionaryList();
        //this.selectTable = {};
      }else if(dictType == 'I') {
        this.handleClick(this.selectTable);
      }else{
        this.queryDiciionaryList();
      }
    },

	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	.dictionaryList,.z-plate__container,.dict-table-content{
		height: 100%;
	}
	.table-content{
		height: calc(100% - 40px);
	}
</style>